import { NextContentfulImage } from "@components/Image";
import Link from "@components/Link/Link";
import {
  TypeNavLinkListFields,
  TypeNavLinkPanelFields,
} from "@customTypes/contentful";
import { navigationGAClick } from "@utilities/navigationGAClick";
import clsx from "clsx";
import { FC } from "react";
import { useNavigationStateContext } from "../../context/navigationContext";
import ArrowSvg from "../../public/image/svg/arrow.svg";
import styles from "./MegaNav.module.scss";

type Props = {
  mainMenuLink: TypeNavLinkPanelFields | TypeNavLinkListFields;
};

const PromoItemAside: FC<Props> = ({ mainMenuLink }) => {
  const { handleReset } = useNavigationStateContext();

  return (
    <div className={clsx("w-1/4", styles.promo)}>
      {mainMenuLink.promoItems &&
        mainMenuLink.promoItems.slice(0, 2).map((promoItem, index) => {
          const url = promoItem.fields.link.fields.url;
          const linkText = promoItem?.fields?.link?.fields?.linkText;
          const key = `${linkText || "#"}${index}`;
          return (
            <Link
              key={key}
              href={url}
              className={styles.item}
              onClick={(e) => {
                navigationGAClick(e);
                handleReset();
              }}
              aria-label={linkText}
            >
              <span className={styles.imageWrapper}>
                <NextContentfulImage
                  // @ts-expect-error not sure about this since there is no contentful type for url
                  src={promoItem.fields.image.fields.url}
                  alt={promoItem.fields.image.fields.altText || ""}
                  fill
                  aria-hidden="true"
                />
              </span>
              {linkText && (
                <span className={clsx(styles.cta, "flex items-center w-full")}>
                  <ArrowSvg aria-hidden="true" focusable="false" />
                  <span
                    className={clsx(styles.text, "font-bold text-[1.125rem]")}
                    id={key}
                  >
                    {linkText}
                  </span>
                </span>
              )}
            </Link>
          );
        })}
    </div>
  );
};

export default PromoItemAside;
